import React from 'react';
import './spinner.css';

const Spinner = ({ className }) => <div className={`spinner ${className}`} />;

export default Spinner;
